import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export const NavLink = ({ to, ...rest }) => {
    return <Link component={RouterLink} to={to} {...rest} />;
};
